import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import endpointsReducer from './slices/endpointsSlice';
import requestsReducer from './slices/requestsSlice';
import collectionsReducer from './slices/collectionsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    endpoints: endpointsReducer,
    requests: requestsReducer,
    collections: collectionsReducer,
  },
});

